module.exports = __webpack_public_path__ + "img/wode.25d582cf.png";